export const displayValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—'
  }
  return value
}

export const calcSuccessRate = (sucCount, reqCount) => {
  const total = Number(reqCount)
  const success = Number(sucCount)
  if (!total || total <= 0) {
    return '—'
  }
  return ((success / total) * 100).toFixed(1) + '%'
}

export const formatMilliseconds = (ms) => {
  if (ms === null || ms === undefined || ms === '') {
    return '—'
  }
  return `${ms} ms`
}

export const formatDateTime = (dateString) => {
  if (!dateString) {
    return '—'
  }
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  }
  return new Date(dateString).toLocaleString(undefined, options)
}

/** apiStatus: 0 success, 1 fail, 2 timeout */
export const getApiStatusMeta = (status, lng) => {
  const code = Number(status)
  if (code === 0) {
    return {
      label: lng.ApiStatusSuccess || 'Success',
      className: 'list-status-badge list-status-success',
    }
  }
  if (code === 1) {
    return {
      label: lng.ApiStatusFail || 'Failed',
      className: 'list-status-badge list-status-fail',
    }
  }
  if (code === 2) {
    return {
      label: lng.ApiStatusTimeout || 'Timeout',
      className: 'list-status-badge list-status-warning',
    }
  }
  return {
    label: displayValue(status),
    className: 'list-status-badge list-status-info',
  }
}
